export const SET_HOTELS_TAB = 'SET_HOTELS_TAB';
export const CLEAN_HOTELS_TAB = 'CLEAN_HOTELS_TAB';

export const setHotelsTab = () => ({
   type: SET_HOTELS_TAB
});

export const cleanHotelTabs = () => ({
   type: CLEAN_HOTELS_TAB
})



// WEBPACK FOOTER //
// ./src/actions/tabActions.js